/**
 * @group Constants

@summary
<blockquote>HTTP method constants for API requests.</blockquote>

@example
```typescript
import { HTTP_METHODS } from '@shared/httpService';

const request = {
  method: HTTP_METHODS.GET,
  url: '/api/users'
};
```
 * @internal
 */
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
} as const;
